class ProductVariantDropdown extends VariantSelects {
    constructor() {
        super();
        this.querySelectorAll('.product-variant-dropdown').forEach(dropdown => {
            const button = dropdown.querySelector('.product-variant-dropdown__button');
            button.addEventListener('click', () => {
                this.querySelectorAll('.product-variant-dropdown').forEach(otherDropdown => {
                    if (otherDropdown !== dropdown) {
                        otherDropdown.classList.remove('is-open');
                    }
                });
                dropdown.classList.toggle('is-open');
            });
            dropdown.querySelectorAll('li').forEach(item => {
                item.addEventListener('click', () => {
                    this.onSelect(item);
                });
            });
            this.updateButton(
                dropdown.querySelector('[data-selected="true"]'),
                dropdown
            );
        });
        document.addEventListener('click', (event) => {
            if (!this.contains(event.target)) {
                this.querySelectorAll('.product-variant-dropdown')
                    .forEach(dropdown => dropdown.classList.remove('is-open'));
            }
        });
    }

    onSelect(item) {
        const dropdown = item.closest('.product-variant-dropdown');
        dropdown.querySelectorAll('li').forEach(li => {
            li.dataset.selected = "false";
        });
        item.dataset.selected = "true";
        dropdown.classList.remove('is-open');
        this.updateButton(item, dropdown);
        this.onVariantChange({
            target: item
        });
    }

    updateOptions() {
        this.options = Array.from(
            this.querySelectorAll('.product-variant-dropdown'),
            dropdown => dropdown.querySelector('[data-selected="true"]').dataset.optionValue
        );
    }

    updateButton(item, dropdown) {
        if (!item || !dropdown) return;
        const itemText = item.querySelector('.product-variant-dropdown-item-title');
        const button = dropdown.querySelector('.product-variant-dropdown__button');
        const image = item.querySelector('.product-variant-dropdown__image');
        const buttonImage = button.querySelector('.selected-variant-image');
        const buttonText = button.querySelector('span');
        if (itemText && buttonText) {
            buttonText.textContent = itemText.textContent;
        }
        if (buttonImage) {
            buttonImage.style.display = "block";
            if (image) {
                buttonImage.src = image.src;
            } else {
                buttonImage.style.display = "none";
            }
        }
        button.classList.toggle(
            'unavailable',
            item.dataset.isAvailable === "false"
        );
    }

    updateVariantStatuses() {
        const dropdowns = [...this.querySelectorAll('.product-variant-dropdown')];
        dropdowns.forEach((dropdown, index) => {
            const availableOptions = this.variantData
                .filter(variant => {
                    for (let optionIndex = 0; optionIndex < index; optionIndex++) {
                        if (variant.options[optionIndex] !== this.options[optionIndex]) {
                            return false;
                        }
                    }
                    return variant.available;
                })
                .map(variant => variant.options[index]);
            dropdown.querySelectorAll('li').forEach(item => {
                const isAvailable = availableOptions.includes(item.dataset.optionValue);
                item.dataset.isAvailable = isAvailable;
                item.classList.toggle('disabled', !isAvailable);
            });

            const selectedItem = dropdown.querySelector('[data-selected="true"]');
            const button = dropdown.querySelector('.product-variant-dropdown__button');

            if (selectedItem && button) {
                button.classList.toggle(
                    'unavailable',
                    selectedItem.dataset.isAvailable === 'false'
                );
            }
        });
    }
}

customElements.define('product-variant-dropdown', ProductVariantDropdown);